import { degToRad } from 'three/src/math/MathUtils';

export class VSSettings {
  id?: number;

  tourId: number;

  ambientLight: number;

  pointLight: number;

  lightHeight: number;

  shadowIntensity: number;

  lightAngle: number;

  updatedAt?: string;

  directionalLightStrength: number;

  directionalLightAngleX: number;

  directionalLightAngleY: number;

  constructor(model: any = {}) {
    this.id = model.id;
    this.tourId = model.tourId;
    this.ambientLight = model.ambientLight || 9.5;
    this.pointLight = model.pointLight || 33 * 3;
    this.lightHeight = model.lightHeight || 75 * 0.5;
    this.shadowIntensity = model.shadowIntensity >= 0 ? model.shadowIntensity : 0.2;
    this.lightAngle = model.lightAngle || 0;
    this.directionalLightStrength = model.directionalLightStrength || 0;
    this.directionalLightAngleX = model.directionalLightAngleX
      ? degToRad(model.directionalLightAngleX * 4) / Math.PI
      : 0;
    this.directionalLightAngleY = model.directionalLightAngleY
      ? degToRad(model.directionalLightAngleY * 4) / Math.PI
      : 0;
    this.updatedAt = model.updatedAt;
  }
}
